<template>
  <div>
    <loading-spinner v-if="loading"></loading-spinner>
    <template v-else>
      <header-card
        :image="image"
        :icon="icon"
        :title="title"
        sub-title="Manage the questions going out to your team"
      >
        <template v-slot:right>
          <div class="secondary--text font-weight-medium subtitle-1">
            Active Question
          </div>
          <div>
            <span class="success--text">{{ active_questions.length }}</span>
            of {{ questions.length }}
          </div>
        </template>
      </header-card>
      <v-card>
        <category-card
          v-for="(category, i) in categories"
          :key="i"
          :category="category"
          :manager-link="manage_link(category)"
          v-on:toggle="toggleCategory(category, $event)"
          v-on:edit="editCategory(category)"
          v-on:delete="deleteCategory(category.id)"
          v-on:manager="manageQuestions(category)"
          :featureId="featureId"
        ></category-card>
        <add-category-card v-on:add="editCategory(null)"></add-category-card>
      </v-card>
    </template>
    <edit-category-dialog
      :featureId="featureId"
      ref="editCategory"
    ></edit-category-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import EditCategoryDialog from "@/components/questions/EditCategoryDialog";
import HeaderCard from "@/components/common/HeaderCard";
import AddCategoryCard from "@/components/questions/AddCategoryCard";
import CategoryCard from "@/components/questions/CategoryCard";
export default {
  name: "Questions",
  components: {
    EditCategoryDialog,
    HeaderCard,
    AddCategoryCard,
    CategoryCard
  },
  props: { featureId: { type: Number } },
  data: () => ({
    saving: false,
    loading: false
  }),
  computed: {
    manage_link() {
      return category => {
        if (this.featureId != this.$enums.features.PULSE) {
          return null;
        }
        switch (category.id) {
          case 2:
            return "/company";
          case 3:
            return "/company/mission";
          default:
            return null;
        }
      };
    },
    active_questions() {
      return this.questions.filter(x => x.isEnabled);
    },
    questions() {
      return this._.flatten(this.categories.map(x => x.questions));
    },
    categories() {
      return this.$store.getters[this.categoriesGetter];
    },
    categoriesGetter() {
      switch (this.featureId) {
        case this.$enums.features.PULSE:
          return "pulse/categories";
        case this.$enums.features.REVIEW:
          return "settings/review_categories";
      }
      return "";
    },
    getAction() {
      switch (this.featureId) {
        case this.$enums.features.PULSE:
          return "pulse/getQuestions";
        case this.$enums.features.REVIEW:
          return "settings/getReviewCategories";
      }
      return "";
    },
    toggleAction() {
      switch (this.featureId) {
        case this.$enums.features.PULSE:
          return "pulse/toggleCategory";
        case this.$enums.features.REVIEW:
          return "settings/toggleReviewCategory";
      }
      return "";
    },
    deleteAction() {
      switch (this.featureId) {
        case this.$enums.features.PULSE:
          return "pulse/deleteCategory";
        case this.$enums.features.REVIEW:
          return "settings/deleteReviewQuestionCategory";
      }
      return "";
    },
    icon() {
      switch (this.featureId) {
        case this.$enums.features.REVIEW:
          return "360";
      }
      return "";
    },
    title() {
      switch (this.featureId) {
        case this.$enums.features.PULSE:
          return "Culture Tracking Questions";
        case this.$enums.features.REVIEW:
          return "360 Review Management";
      }
      return "";
    },
    image() {
      switch (this.featureId) {
        case this.$enums.features.PULSE:
          return this.$images.PULSE_ICON;
      }
      return "";
    },
    ...mapGetters({})
  },
  created() {
    this.loadQuestions();
  },
  methods: {
    editCategory(category) {
      this.$refs.editCategory.showDialog(category || {});
    },
    manageQuestions(category) {
      this.$refs.questionDialog.showDialog(category);
    },
    loadQuestions() {
      this.loading = true;
      Promise.all([this.$store.dispatch(this.getAction)])
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading questions."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toggleCategory(category, event) {
      this.$store
        .dispatch(this.toggleAction, {
          id: category.id,
          isEnabled: event || false
        })
        .then(() => {
          this.$root.$snackbarSuccess("Category updated");
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while saving categories"
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async deleteCategory(id) {
      if (
        await this.$root.$confirm(
          "Delete category",
          "Are you sure you want to delete this category?",
          { color: "red" }
        )
      ) {
        this.saving = true;
        this.$store
          .dispatch(this.deleteAction, id)
          .then(() => {
            this.$emit("save");
            this.$root.$snackbarSuccess("Category deleted");
            this.dialog = false;
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occured while deleting a category."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>
